module.exports = __webpack_public_path__ + "img/32.928da744.jpg";